// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__sjJDx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__WMguf"};